
export function isEmpty(value) {
  return (value === null || value === undefined || value.length === 0);
}

export function isBlank(value) {
  return (value === null || value === undefined || value === '');
}

export function isNull(value) {
  return (value === null || value === undefined);
}

export function isPageReload() {
  return window.performance
  .getEntriesByType('navigation')
  .map((nav) => nav.type)
  .includes('reload');
}
